import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getPaymentGateway } from '../../../api/flightApi';
import { getUserAgentId } from '../../helper-utils/localStorage';
import AppRadioInput from '../app-radio-input/AppRadioInput';

function AppPaymentGatewaySelector({
  paymentModeClicked,
  selectedPgForPaymentMode,
  onPgSelect,
}) {
  const [paymentGateways, setPaymentGateways] = useState([]);

  useEffect(() => {
    let active = true;

    const fetchPaymentGateways = async () => {
      const response = await getPaymentGateway(getUserAgentId());
      const available =
        response?.Root?.Result?.AvailablePaymentGateways
          ?.AvailablePaymentGateway;

      if (
        active &&
        response?.Root?.Status === 'OK' &&
        Number(response?.Root?.StatusCode) === 200 &&
        available
      ) {
        setPaymentGateways(Array.isArray(available) ? available : [available]);
      }
    };

    fetchPaymentGateways();
    return () => {
      active = false;
    };
  }, []);

  const matchingGateways = useMemo(
    () =>
      paymentGateways.filter(
        (gateway) => gateway.PaymentMode?.toLowerCase() === paymentModeClicked,
      ),
    [paymentGateways, paymentModeClicked],
  );

  useEffect(() => {
    if (
      matchingGateways.length > 0 &&
      !matchingGateways.some(
        (gateway) => gateway.GatewayName === selectedPgForPaymentMode,
      )
    ) {
      onPgSelect(matchingGateways[0].GatewayName);
    }
  }, [matchingGateways, onPgSelect, selectedPgForPaymentMode]);

  if (matchingGateways.length === 0) return null;

  return (
    <div className="d-flex justify-content-start gap-4">
      <div className="flight-booking-page_title">Payment Gateway</div>
      {matchingGateways.map((gateway) => (
        <AppRadioInput
          key={gateway.GatewayName}
          id={gateway.GatewayName}
          name="paymentGateway"
          labelText={
            gateway.GatewayName === 'techprocessv2'
              ? 'Worldline'
              : gateway.GatewayName
          }
          value={gateway.GatewayName}
          onChange={() => onPgSelect(gateway.GatewayName)}
          checked={selectedPgForPaymentMode === gateway.GatewayName}
        />
      ))}
    </div>
  );
}

AppPaymentGatewaySelector.propTypes = {
  paymentModeClicked: PropTypes.string.isRequired,
  selectedPgForPaymentMode: PropTypes.string.isRequired,
  onPgSelect: PropTypes.func.isRequired,
};

export default AppPaymentGatewaySelector;
